import { makeAutoObservable, action } from "mobx";

export interface RangeData {
	x: number;
	x2: number;
}

export class RangeStore {
	name: string;
	color: string;
	visible: boolean = true;
	data: RangeData[] = [];

	constructor(name: string, color: string) {
		this.name = name;
		this.color = color;

		makeAutoObservable(this, {
			setColor: action,
			toggleVisible: action,
			setData: action,
		});
	}

	setColor(color: string) {
		this.color = color;
	}

	toggleVisible() {
		this.visible = !this.visible;
	}

	setData(data: RangeData[]) {
		this.data = data;
	}
}
